import React from 'react';
import { FieldDefinition } from './FieldRenderer';

interface DynamicDropdownFieldProps {
  field: FieldDefinition;
  value: any;
  onChange: (fieldKey: string, value: any) => void;
  error?: string;
  disabled?: boolean;
  isArabic: boolean;
}

const DynamicDropdownField: React.FC<DynamicDropdownFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  isArabic
}) => {
  const label = isArabic ? field.label_ar || field.label : field.label;
  const placeholder = isArabic ? field.placeholder_ar || field.placeholder : field.placeholder;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(field.key, e.target.value);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        required={field.required}
        className={`w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${
          isArabic ? 'text-right' : 'text-left'
        }`}
        dir={isArabic ? 'rtl' : 'ltr'}
      >
        <option value="">
          {placeholder || (isArabic ? 'اختر خيار...' : 'Select an option...')}
        </option>
        {field.options?.map((option, index) => (
          <option key={index} value={option.value}>
            {isArabic ? option.label_ar || option.label : option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default DynamicDropdownField;